export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["None"] = "None";
    TransactionStatus["Pending"] = "Pending";
    TransactionStatus["Success"] = "Success";
    TransactionStatus["Failed"] = "Failed";
})(TransactionStatus || (TransactionStatus = {}));
export function createTransactionContext(props) {
    if (props.status === TransactionStatus.Success) {
        if (props.transaction && props.receipt) {
            return {
                status: props.status,
                data: props.data,
                transaction: props.transaction,
                receipt: props.receipt,
                error: undefined,
            };
        }
        else {
            throw new Error('Invalid transaction context: missing transaction or receipt');
        }
    }
    return {
        status: props.status,
        data: props.data,
        transaction: props.transaction,
        receipt: undefined,
        error: props.error,
    };
}
export function logTxnResult(name, txn) {
    if (txn.status === TransactionStatus.Success) {
        console.log(`[${name}]`, 'Success', txn.data, txn);
    }
    else if (txn.status === TransactionStatus.Failed) {
        console.error(`[${name}]`, 'Failed', txn.error, txn);
    }
}
export var JoinFlowStatus;
(function (JoinFlowStatus) {
    JoinFlowStatus["JoiningRoom"] = "joining-room";
    JoinFlowStatus["JoiningAutojoinChannels"] = "joining-autojoin-channels";
    JoinFlowStatus["VerifyingMembership"] = "verifying-membership";
    JoinFlowStatus["AlreadyMember"] = "already-member";
    JoinFlowStatus["MintingMembership"] = "minting-membership";
    JoinFlowStatus["MembershipMinted"] = "membership-minted";
    JoinFlowStatus["Error"] = "error";
})(JoinFlowStatus || (JoinFlowStatus = {}));
export var CreateSpaceFlowStatus;
(function (CreateSpaceFlowStatus) {
    CreateSpaceFlowStatus["MintingSpace"] = "minting-space";
    CreateSpaceFlowStatus["CreatingSpace"] = "creating-space";
    CreateSpaceFlowStatus["CreatingChannel"] = "creating-channel";
    CreateSpaceFlowStatus["CreatingUser"] = "creating-user";
    CreateSpaceFlowStatus["Error"] = "error";
})(CreateSpaceFlowStatus || (CreateSpaceFlowStatus = {}));
//# sourceMappingURL=TownsClientTypes.js.map